import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layers/presentation/components/common/PageHero.tsx");
